import { LOCAL_STORAGE_KEYS } from '../../constants/AppConstants';
import { PBStorage } from '../../services/storageService/GlobalData';

class WorkerManager {
  //saveActivities
  async saveWorkers(workersToSave) {
    try {
      await PBStorage.set(LOCAL_STORAGE_KEYS.WORKER, workersToSave);
      return true;
    } catch (e) {
      console.log('saveWorkersfailed', e);
      return false;
    }
  }

  async getWorkers() {
    let users = (await PBStorage.get(LOCAL_STORAGE_KEYS.WORKER)) || [];
    return users;
  }
}

export default new WorkerManager();
